export type Calories = {
  value: number;
  unit: 'kcal';
};

const KJ_PER_KCAL: number = 4.1868;

/**
 * Estimation des calories d'une seance (reprise du back : `generateCalories`).
 * L'elliptique (equipement 4) a une puissance et un rendement plus faibles.
 *
 * @param sport sport de la seance, seul `elliptical` change le calcul
 * @param duration duree en secondes
 */
export function generateCalories(sport: string | undefined, duration: number): Calories {
  const isElliptical: boolean = sport === 'elliptical';
  const watt: number = isElliptical ? 100 : 120;
  const ratio: number = isElliptical ? 0.16 : 0.25;

  return {
    value: Math.round((watt / 1000 / KJ_PER_KCAL / ratio) * duration),
    unit: 'kcal',
  };
}
